// @flow

export const BASE_URL = '/app/settings';
export const CREDIT_CARD_URL = '/app/settings/billing?section=card';
export const SETTINGS_QUESTIONNAIRE_SWITCH = 'settings_questionnaire';

export const TEAM_COMPANIES_QUESTIONNAIRE = '317oku46';
export const SINGLE_ACCOUNT_QUESTIONNAIRE = '25c4qfg4';
